import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getAcreageStrParts, getRegionsDisplay } from 'shared/utils';
import { Wildfire } from 'features/wildfires/wildfire.types';
import { GeoEventUpdateTime } from 'features/geoEvents/components/GeoEventUpdateTime';
import { StatTable } from 'components/StatTable';

type WildfireEmbedContentProps = {
  geoEvent: Wildfire;
};

export const WildfireEmbedContent = ({
  geoEvent,
}: WildfireEmbedContentProps): JSX.Element => {
  const { t, i18n } = useTranslation();

  const {
    data: { acreage, containment, isFps },
    address,
    regions,
  } = geoEvent;

  const [acreageStr] = getAcreageStrParts(
    acreage,
    containment,
    i18n.resolvedLanguage,
  );

  return (
    <>
      {Boolean(address) && <Typography>{address}</Typography>}

      <Typography variant="body2" color="textSecondary">
        {getRegionsDisplay(regions)}
      </Typography>

      <StatTable
        stats={[
          {
            label: t('geoEvent.acres'),
            value: acreageStr,
            testId: 'acresBox',
          },
          {
            label: t('geoEvent.containment'),
            value:
              !isFps && typeof containment === 'number'
                ? `${containment}%`
                : null,
            testId: 'containmentBox',
          },
        ]}
        itemSize={6}
      />

      <GeoEventUpdateTime geoEvent={geoEvent} sx={{ mb: '-16px !important' }} />
    </>
  );
};
